import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from '../../../Auth'
import { Filter, Search, XLg } from 'react-bootstrap-icons';
import { Badge, Button, ButtonGroup, FormControl, FormSelect, InputGroup, ListGroup, ListGroupItem, Modal, Pagination, Spinner } from 'react-bootstrap';
import { fetchApi, range } from '../../../Funciones';
import { Preview } from './Preview';
import { TagList, TagSelector } from '../Tags/Manager';

export const ContentSelector: React.FC<{ value: any, onChange: Function }> = ({ value, onChange }) => {

    let auth = useAuth();
    const [mostrar, setMostrar] = useState(false)

    const [filtro, setFiltro] = useState("")
    const [listado, setListado] = useState<any>([])
    const [pagina, setPagina] = useState(0)
    const [porPagina, setPorPagina] = useState(parseInt(localStorage.getItem("porPagina") + ""))
    const [cargando, setCargando] = useState(false)
    const [total, setTotal] = useState(0)
    const [filtroTags, setFiltroTags] = useState<any[]>(localStorage.getItem("fTags") ? JSON.parse(localStorage.getItem("fTags") + "") : [])

    var paginas = range(1, Math.ceil(total / porPagina) + 1)

    const getData = async () => {
        setCargando(true)
        var data = await fetchApi(auth.user.token, "content", {
            cmd: "search",
            //nocontent:1,
            s: filtro,
            p: pagina,
            pp: porPagina,
            tags: filtroTags.map(item => item.id).join(","),
            estados: "Published"
        })
        setListado(data.listado)
        setTotal(data.total)
        setCargando(false)
    }

    useEffect(() => {
        if (auth.user && mostrar) {
            getData()
            setInit(true)
        }
        else {
            setFiltro("")
            setListado([])
        }
        // eslint-disable-next-line
    }, [auth.user, mostrar])


    const timeRef = useRef<any>(null)
    const [init, setInit] = useState(false)
    useEffect(() => {
        if (!init) {
            return
        }

        clearTimeout(timeRef.current!)

        timeRef.current = setTimeout(() => {
            getData()
        }, 300)
        // eslint-disable-next-line
    }, [filtro, filtroTags])

    useEffect(() => {
        return () => clearTimeout(timeRef.current!)
    }, [])

    const seleccionar = (data: any) => {
        setMostrar(false)

        onChange(data)
    }

    return <>
        <ButtonGroup>
            <ButtonGroup vertical>
                <Button variant={value !== "" ? "dark" : "primary"} size='sm' onClick={() => setMostrar(true)}><Search /></Button>
                {value !== "" && <Button variant='danger' size='sm' onClick={() => onChange("")}><XLg /></Button>}
            </ButtonGroup>
            {value !== "" && <Preview data={value}><Button variant='outline-primary' size='sm'>{value.title}</Button></Preview>}
        </ButtonGroup>

        <Modal show={mostrar} backdrop="static" onHide={() => { setMostrar(false) }} size="lg" centered fullscreen={"sm-down"}>
            <Modal.Header closeButton>Seleccione Contenido</Modal.Header>
            <Modal.Body>

                <div className="py-2">
                    <div className="d-inline-block">
                        <InputGroup>
                            <FormControl type="text" placeholder='Buscar Contenido' value={filtro} onChange={(ev) => setFiltro(ev.target.value)} />
                            <Button variant="outline-danger" onClick={() => setFiltro("")}><XLg /></Button>
                        </InputGroup>
                    </div>
                    <FormSelect className="d-inline-block w-auto ms-2" title="Por Página" value={porPagina} onChange={(ev) => {
                        setPagina(0)
                        setPorPagina(parseInt(ev.target.value));
                        localStorage.setItem("porPagina", ev.target.value)
                    }}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </FormSelect>
                    {total > porPagina && <div className="d-inline-block ms-2">
                        <Pagination>
                            <Pagination.First onClick={() => setPagina(0)} />
                            {paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
                            <Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
                        </Pagination>
                    </div>}
                    <div className={"d-inline-block ms-4 border px-2 py-1 "+(filtroTags.length>0?"border border-primary rounded":"")}>
                        {filtroTags.length > 0 && <div><TagList list={filtroTags} /></div>}
                        <TagSelector current={filtroTags} onSelect={(tags: any) => {
                            localStorage.setItem("fTags", JSON.stringify(tags))
                            setFiltroTags(tags)
                        }}><Button size="sm" variant="secondary"><Filter /> Filtrar Etiquetas</Button></TagSelector>
                    </div>
                    {cargando && <Spinner animation="border" className="d-inline-block ms-2" size='sm' />}
                </div>

                <ListGroup>
                    {listado.map((item: any) => <ListGroupItem action onClick={() => seleccionar(item)} variant='dark' key={item.id} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <span>{item.title}</span>
                        <span className='d-flex flex-row small'>
                            <span className='mx-1'>
                                <TagList list={item.tags} separator={<br />} />
                            </span>
                            <span className='text-center'>
                                <Badge bg='dark'>{item.publish_date.split(" ")[0]}</Badge><br />
                                <Badge bg='secondary'>{item.publish_date.split(" ")[1].substr(0, 5)}</Badge>
                            </span>
                        </span>
                    </ListGroupItem>)}
                </ListGroup>

            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="danger" onClick={() => setMostrar(false)}><XLg /> Cancelar</Button>
            </Modal.Footer>
        </Modal>
    </>
}